import { Button, Card, Modal, Space, Tag, Typography } from "antd";
import React, { useEffect, useState } from "react";
import SubscriptionModal from "./SubscriptionModal";
import SuccessPage from "./SuccessPage";
import FailedPage from "./FailedPage";
import LoadingPage from "./LoadingPage";
import { useSelector } from "react-redux";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { CalendarOutlined, CrownOutlined } from "@ant-design/icons";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";

// Load Razorpay script
const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const MySubscription = ({ currentSubscription, refreshSubscription }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [isLoadingModalOpen, setIsLoadingModalOpen] = useState(false);
  
  const userData = useSelector(({ auth }) => auth?.userData);
  const authUser = useSelector(({ auth }) => auth.userData);
  const userId = userData?.id;
  const userUuid = userData?.uuid;
  
  console.log("authUsercheck0001", authUser?.Subscription);
  const currentSubscriptionFromAuth = authUser?.Subscription;
  const [subscriptionData, setSubscriptionData] = useState(null);
  console.log("subscriptionData",subscriptionData)
  const subscriptionPlan = subscriptionData?.subscription?.planId || authUser?.subscription?.planId;
  
  const planName = subscriptionPlan === 1 ? 'Trial' : 
                   subscriptionPlan === 2 ? 'Basic' : 
                   subscriptionPlan === 3 ? 'Premium' : 
                   'No Active Plans';
  
  const { isMobile } = useGetBreakpoints();
  const PlanExpires = subscriptionData?.subscription?.endDate;
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const isActiveTag = subscriptionData?.isActive;
  const [userDetails, setUserDetails] = useState(null);

  console.log("userDetails", userDetails);
  const SubscriptionValidity = userDetails?.SubscriptionValidity;
  const subscriptionStatus = userDetails?.Subscription;
  const isTrialActive = userDetails?.IsTrailActive;
  const trialEndDate = userDetails?.TrialEndDate;

  // Determine display status based on trial and subscription
  const getDisplayStatus = () => {
    if (isTrialActive === true) {
      return "Premium Trial";
    } else if (subscriptionStatus === "Premium") {
      return "Premium";
    } else if (subscriptionStatus === "Free") {
      return "Free";
    } else {
      return subscriptionStatus || "Free";
    }
  };

  const displayStatus = getDisplayStatus();
  
  // Check if user can upgrade (only show upgrade for Free users, not for Trial users)
  const canUpgrade = subscriptionStatus === "Free" && !isTrialActive;

  const fetchUserDetails = async () => {
    if (!userId) return;
    
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/users/${userId}`
      );
      console.log("User details from API:", response.data);
      setUserDetails(response.data?.data || response.data);
      
      if (refreshSubscription) {
        await refreshSubscription();
      }
      
    } catch (err) {
      setError(err.message);
      console.error('User details fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchUserDetails();
    }
  }, [userId]);

  // Check if user is free
  const isFreeUser = subscriptionStatus === 'Free';
  const isPremiumUser = subscriptionStatus === 'Premium';
  
  const PREMIUM_AMOUNT = 5999; // Amount in rupees
  const PREMIUM_PLAN_ID = 3; // Assuming Premium plan ID is 3

  const fetchSubscription = async () => {
    try {
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/subscription-plans/user/${userId}`
      );
      setSubscriptionData(response.data);
      console.log("Response from the backend ", response?.data?.subscription?.planId);
      
      if (refreshSubscription) {
        await refreshSubscription();
      }
      
    } catch (err) {
      setError(err.message);
      console.error('Subscription fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchSubscription();
    }
  }, [userId]);

  const handleRefresh = async () => {
    await fetchSubscription();
    if (refreshSubscription) {
      refreshSubscription();
    }
  };

  // Direct Razorpay payment for premium upgrade
  const handlePremiumUpgrade = async () => {
    try {
      // Load Razorpay script

      if (subscriptionStatus === "Premium") {
        Modal.info({
          title: "Already on Premium Plan",
          content: "You are already subscribed to the Premium plan. You can manage your subscription from the dashboard.",
          okText: "Got it",
        });
        return; // Stop execution here
      }

      if (isTrialActive === true) {
        Modal.info({
          title: "Trial Period Active",
          content: "You are currently on a Premium Trial. You can upgrade after your trial ends.",
          okText: "Got it",
        });
        return; // Stop execution here
      }

      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        alert("Failed to load payment gateway. Please try again.");
        return;
      }

      setIsLoadingModalOpen(true);

      // Create subscription order on your backend
      const orderResponse = await axiosInstance.post(
        `${BASE_API_CONFIG.baseURL}/subscription-plans/create-subscription-order`,
        {
          planId: PREMIUM_PLAN_ID,
          priceAmount: PREMIUM_AMOUNT * 100, // Razorpay expects amount in paise
          currency: "INR",
          uuid: userUuid,
          isYearly: true, // Assuming yearly subscription
          baseName: "Premium",
          receipt: `premium_${userId}_${Date.now()}`
        }
      );

      const orderData = orderResponse.data;
      console.log("Order created:", orderData);
      
      // Razorpay options
      const options = {
        key: process.env.REACT_APP_RZP_KEY_ID,
        amount: orderData.amount,
        currency: orderData.currency,
        name: "My Exim Business",
        description: "Premium Subscription Upgrade",
        image: "https://myeximbusiness.com/favicon.ico",
        order_id: orderData.id,
        handler: async function (response) {
          // Payment successful
          console.log("Payment Success:", response);
          
          try {
            // Verify payment on your backend
            const verifyResponse = await axiosInstance.post(
              `${BASE_API_CONFIG.baseURL}/subscription-plans/verify-payment`,
              {
                orderId: response.razorpay_order_id,
                paymentId: response.razorpay_payment_id,
                signature: response.razorpay_signature,
                planId: PREMIUM_PLAN_ID,
                uuid: userUuid
              }
            );

            if (verifyResponse.data.success) {
              // Subscribe user after successful payment
              await axiosInstance.post(
                `${BASE_API_CONFIG.baseURL}/subscription-plans/subscribe`,
                {
                  planId: PREMIUM_PLAN_ID,
                  userId: userId,
                  email: userData?.email,
                  isYearly: true,
                  razorpayOrderId: response.razorpay_order_id,
                  razorpayPaymentId: response.razorpay_payment_id,
                  signature: response.razorpay_signature
                }
              );

              setIsLoadingModalOpen(false);
              setIsSuccessModalOpen(true);
              await handleRefresh(); // Refresh subscription data
              setTimeout(() => {
                window.location.reload(); // This will refresh the entire page
              }, 3000);
            } else {
              throw new Error("Payment verification failed");
            }
          } catch (verifyError) {
            console.error("Verification Error:", verifyError);
            setIsLoadingModalOpen(false);
            setIsFailedModalOpen(true);
          }
        },
        prefill: {
          name: userData?.name || "",
          email: userData?.email || "",
          contact: userData?.phone || ""
        },
        notes: {
          userId: userId,
          planType: "Premium"
        },
        theme: {
          color: "#28aa96"
        },
        modal: {
          ondismiss: function() {
            setIsLoadingModalOpen(false);
            console.log("Payment modal closed");
          }
        }
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
      
    } catch (error) {
      console.error("Payment Error:", error);
      setIsLoadingModalOpen(false);
      setIsFailedModalOpen(true);
    }
  };

  const openSubscriptionModal = () => {
    setIsModalOpen(true);
  };

  const closeSubscriptionModal = () => {
    setIsModalOpen(false);
  };

  const openSuccessModal = () => {
    setIsSuccessModalOpen(true);
  };

  const closeSuccessModal = () => {
    setIsSuccessModalOpen(false);
  };

  const openFailedModal = () => {
    setIsFailedModalOpen(true);
  };

  const closeFailedModal = () => {
    setIsFailedModalOpen(false);
  };
  
  const openLoadingModal = () => {
    setIsLoadingModalOpen(true);
  };

  const closeLoadingModal = () => {
    setIsLoadingModalOpen(false);
  };

  const renderMobileView = () => (
    <Card
      style={{
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        marginBottom: "16px",
        border: "none"
      }}
      bodyStyle={{ padding: "16px" }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {/* Plan Info Section */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
              <Typography.Text strong style={{ fontSize: "16px" }}>
                Current Plan: {displayStatus}
              </Typography.Text>
              {isTrialActive === true && (
                <Tag color="blue" style={{ borderRadius: 12, fontWeight: 400 }}>
                  TRIAL ACTIVE
                </Tag>
              )}
            </div>
          </div>
          
          {/* Show upgrade button only for Free users (not on trial) */}
          {canUpgrade ? (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px" }}>
              <Typography.Text strong style={{ color: "#28aa96", fontSize: "18px" }}>
                ₹{PREMIUM_AMOUNT}
              </Typography.Text>
              <Button
                type="primary"
                size="middle"
                icon={<CrownOutlined />}
                style={{
                  borderRadius: "6px",
                  fontWeight: 500,
                  minWidth: "100px",
                  background: "#28aa96",
                  borderColor: "#28aa96"
                }}
                onClick={handlePremiumUpgrade}
                loading={isLoadingModalOpen}
              >
                Upgrade
              </Button>
            </div>
          ) : (
            // For Trial or Premium users, show disabled button
            <Button
              type="default"
              size="middle"
              icon={<CrownOutlined />}
              style={{
                borderRadius: "6px",
                fontWeight: 500,
                minWidth: "100px",
                opacity: isTrialActive === true ? 0.6 : 1
              }}
              disabled={isTrialActive === true || subscriptionStatus === "Premium"}
              onClick={handlePremiumUpgrade}
            >
              {isTrialActive === true ? "In Trial" : 
               subscriptionStatus === "Premium" ? "Premium" : "Upgrade"}
            </Button>
          )}
        </div>

        {/* Show trial end date if trial is active */}
        {isTrialActive === true && trialEndDate && (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center',
            background: '#e6f7ff',
            padding: '12px 16px',
            borderRadius: 8,
            border: '1px solid #91d5ff'
          }}>
            <CalendarOutlined style={{ color: '#1890ff', marginRight: 12, fontSize: '16px' }} />
            <div>
              <Typography.Text type="secondary" style={{ fontSize: "13px", display: "block" }}>Trial Ends On</Typography.Text>
              <Typography.Text strong style={{ fontSize: "14px", color: "#1890ff" }}>
                {new Date(trialEndDate).toLocaleDateString('en-IN', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric'
                })}
              </Typography.Text>
            </div>
          </div>
        )}

        {/* Show subscription expiry for Premium users (only if not on trial) */}
        {isPremiumUser && !isTrialActive && SubscriptionValidity && (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center',
            background: '#f8f9fa',
            padding: '12px 16px',
            borderRadius: 8,
            border: '1px solid #f0f0f0'
          }}>
            <CalendarOutlined style={{ color: '#28aa96', marginRight: 12, fontSize: '16px' }} />
            <div>
              <Typography.Text type="secondary" style={{ fontSize: "13px", display: "block" }}>Valid Until</Typography.Text>
              <Typography.Text strong style={{ fontSize: "14px" }}>
                {new Date(SubscriptionValidity).toLocaleDateString('en-IN', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric'
                })}
              </Typography.Text>
            </div>
          </div>
        )}

        {/* Price display for Free users */}
        {canUpgrade && (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center',
            justifyContent: 'space-between',
            background: '#f0f9f0',
            padding: '16px',
            borderRadius: 12,
            border: '1px solid #28aa96'
          }}>
            <div>
              <Typography.Text type="secondary" style={{ fontSize: "13px", display: "block" }}>Premium Plan</Typography.Text>
              <Typography.Text strong style={{ fontSize: "24px", color: "#28aa96" }}>
                ₹{PREMIUM_AMOUNT}
                <span style={{ fontSize: "14px", color: "#666", marginLeft: "4px" }}>/year</span>
              </Typography.Text>
            </div>
            <Tag color="gold" style={{ borderRadius: 12, padding: '4px 8px' }}>
              Save 20%
            </Tag>
          </div>
        )}
      </div>
    </Card>
  );

  const renderDesktopView = () => (
    <Card style={{ borderRadius: "8px", marginBottom: "20px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px" }}>
        <div>
          <Typography.Title level={4} style={{ margin: 0 }}>
            Current Plan: {displayStatus}
            {isTrialActive === true && (
              <Tag color="blue" style={{ marginLeft: 12 }}>
                TRIAL ACTIVE
              </Tag>
            )}
          </Typography.Title>
        </div>
        <Space>
          {canUpgrade ? (
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <div>
                <Typography.Text type="secondary" style={{ fontSize: "14px", display: "block" }}>
                  Premium Plan
                </Typography.Text>
                <Typography.Text strong style={{ color: "#28aa96", fontSize: "24px" }}>
                  ₹{PREMIUM_AMOUNT}
                  <span style={{ fontSize: "14px", color: "#666", marginLeft: "4px" }}>/year</span>
                </Typography.Text>
              </div>
              <Button
                type="primary"
                size="medium"
                style={{
                  borderRadius: "8px",
                  background: "#28aa96",
                  borderColor: "#28aa96",
                  height: "48px",
                  padding: "0 24px"
                }}
                onClick={handlePremiumUpgrade}
                loading={isLoadingModalOpen}
              >
                Upgrade to Premium
              </Button>
            </div>
          ) : (
            <Button
              type="default"
              size="medium"
              style={{
                borderRadius: "8px",
                height: "40px",
                padding: "0 24px",
                opacity: isTrialActive === true ? 0.6 : 1
              }}
              disabled={isTrialActive === true || subscriptionStatus === "Premium"}
              onClick={handlePremiumUpgrade}
            >
              {isTrialActive === true ? "In Trial Period" : 
               subscriptionStatus === "Premium" ? "Premium Active" : "Upgrade"}
            </Button>
          )}
        </Space>
      </div>
      
      {/* Show trial end date if trial is active (ONLY this shows for trial users) */}
      {isTrialActive === true && trialEndDate && (
        <div style={{ 
          display: 'inline-flex', 
          alignItems: 'center',
          background: '#e6f7ff',
          padding: '12px 20px',
          borderRadius: 8,
          border: '1px solid #91d5ff',
          marginLeft: '16px',
          marginBottom: '16px'
        }}>
          <CalendarOutlined style={{ color: '#1890ff', marginRight: 12, fontSize: '16px' }} />
          <Typography.Text type="secondary" style={{ marginRight: 8 }}>Trial ends on:</Typography.Text>
          <Typography.Text strong style={{ color: "#1890ff" }}>
            {new Date(trialEndDate).toLocaleDateString('en-IN', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })}
          </Typography.Text>
        </div>
      )}
      
      {/* Expiry date for Premium users (only if not on trial) */}
      {isPremiumUser && !isTrialActive && SubscriptionValidity && (
        <div style={{ 
          display: 'inline-flex', 
          alignItems: 'center',
          background: '#f8f9fa',
          padding: '12px 20px',
          borderRadius: 8,
          border: '1px solid #f0f0f0',
          marginLeft: '16px',
          marginBottom: '16px'
        }}>
          <CalendarOutlined style={{ color: '#28aa96', marginRight: 12, fontSize: '16px' }} />
          <Typography.Text type="secondary" style={{ marginRight: 8 }}>Valid until:</Typography.Text>
          <Typography.Text strong>
            {new Date(SubscriptionValidity).toLocaleDateString('en-IN', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })}
          </Typography.Text>
        </div>
      )}
    </Card>
  );

  return (
    <>
      <div>
        {isMobile ? renderMobileView() : renderDesktopView()}
      </div>

      {isModalOpen && (
        <SubscriptionModal
          isSubscriptionModalOpen={isModalOpen}
          onClose={closeSubscriptionModal}
          openSuccessModal={openSuccessModal}
          openFailedModal={openFailedModal}
          openLoadingModal={openLoadingModal}
          closeLoadingModal={closeLoadingModal}
          refreshSubscription={handleRefresh}
          currentPlan={currentSubscription}
        />
      )}

      {isSuccessModalOpen && (
        <SuccessPage
          isSuccessModalOpen={isSuccessModalOpen}
          onCloseSuccessModal={closeSuccessModal}
          subscriptionDetails={currentSubscription}
        />
      )}

      {isFailedModalOpen && (
        <FailedPage
          isFailedModalOpen={isFailedModalOpen}
          onCloseFailedModal={closeFailedModal}
        />
      )}

      {isLoadingModalOpen && (
        <LoadingPage
          isLoadingModalOpen={isLoadingModalOpen}
          onCloseLoadingModal={closeLoadingModal}
        />
      )}
    </>
  );
};

export default MySubscription;